import { MTableEditField } from '@material-table/core';
import React from 'react';

export default user => {
  const columns = [
    {
      title: 'Nome etapa',
      field: 'name',
      initialEditValue: '',
      width: 800,
      headerStyle: {
        textAlign: 'left',
      },
      cellStyle: {
        textAlign: 'left',
      },
      editComponent: (props) => <MTableEditField fullWidth {...props} multiline/>,
    },
    {
      title: 'Descrição',
      field: 'description',
      initialEditValue: '',
      width: 800,
      headerStyle: {
        textAlign: 'left',
      },
      cellStyle: {
        textAlign: 'left',
      },
      editComponent: (props) => <MTableEditField fullWidth {...props} multiline/>,
    },
  ];

  const columnsAdmin = [
    {
      title: 'ID',
      field: 'id',
      editable: 'never',
      width: 100,
    },
    ...columns
  ];

  return user.superuser ? columnsAdmin : columns;
};
